/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'typedocument': {
    width: 200,
    height: 233.186,
    viewBox: '0 0 200 233.186',
    data: '<g fill-rule="evenodd"><path pid="0" d="M200 196.39V61.84c0-8.29-3.29-16.24-9.15-22.1L160.26 9.15A31.252 31.252 0 00138.16 0H36.8C16.47 0 0 16.48 0 36.8v159.59c0 20.32 16.48 36.8 36.8 36.8h126.4c20.33 0 36.8-16.48 36.8-36.8z" _fill="#4876f9"/><path pid="1" d="M160.258 9.156a31.222 31.222 0 00-16.08-8.57v34.34c0 10.9 8.84 19.74 19.74 19.74h35.24a31.224 31.224 0 00-8.31-14.92l-30.59-30.59z" _fill="#b5c8fc"/><path pid="2" d="M39 93.574h104v-10H39v10zM39 129.574h72v-10H39v10z" _fill="#fff"/></g>'
  }
})
